/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react'
import { css } from '@emotion/react'
import { Input } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import headerImage from './download_app_header.png'
import androidQrCode from './google_play.png'
import iOSQrCode from './app_store.png'
import colors from '@sportninja/common/constants/appColors'
import req from '@sportninja/common/api/request'
import PhoneInputComponent from '../PhoneFormComponent'
import QRCode from 'react-qr-code'
import { isCanlan } from '@sportninja/common/utils/customer-name'

const OpenInAppModal = ({
  onPressClose = () => {},
  gameId = null,
  isTutorial = false,
}) => {
  const [phoneNumber, setPhoneNumber] = useState('')
  const [isSendingSms, setIsSendingSms] = useState(false)
  const [sendSmsError, setSendSmsError] = useState(null)
  const [sendSmsSuccess, setSendSmsSuccess] = useState(false)

  useEffect(() => {
    if (sendSmsError) {
      setTimeout(() => {
        setSendSmsError(null)
      }, [5000])
    }
  }, [sendSmsError])

  useEffect(() => {
    if (sendSmsSuccess) {
      setTimeout(() => {
        setSendSmsSuccess(null)
      }, [5000])
    }
  }, [sendSmsSuccess])

  const onPressSendSms = async () => {
    if (!phoneNumber || phoneNumber?.length === 0) {
      setSendSmsError('Please enter a phone number')
      return
    }
    try {
      setIsSendingSms(true)
      const result = await req(`/games/${gameId}/sms`, {
        method: 'POST',
        body: JSON.stringify({
          phone_number: phoneNumber,
        }),
      })
      setSendSmsSuccess(true)
    } catch (e) {
      setSendSmsError(e?.message || 'Something went wrong')
    } finally {
      setIsSendingSms(false)
    }
  }

  return (
    <div
      css={css`
        background: var(
          --Gradient1,
          linear-gradient(180deg, #282e38 0%, #181a1d 100%)
        );
        min-height: 40vh;
        /* min-width: 40vw;
        max-width: 700px; */
        width: 600px;
        border-radius: 16px;
      `}
    >
      <style>
        {`
          .ant-input {
            background-color: ${colors.HEADER};
          }
        `}
      </style>
      <button onClick={onPressClose}>
        <CloseOutlined
          fontSize={20}
          style={{
            color: colors.WHITE,
            fontSize: 20,
            position: 'absolute',
            top: 35,
            right: 35,
            cursor: 'pointer',
            zIndex: 1,
            transition: 'all 0.2s ease-in-out',
            opacity: 0.8,
            ':hover': {
              opacity: 1,
            },
          }}
        />
      </button>
      <img
        src={headerImage}
        alt='score'
        css={css`
          width: 100%;
          height: 220px;
          border-top-left-radius: 16px;
          border-top-right-radius: 16px;
        `}
      />
      <div
        css={{
          padding: '24px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '16px',
        }}
      >
        <div
          css={css`
            display: flex;
            flex-direction: column;
            gap: 16px;
          `}
        >
          <span
            css={css`
              color: var(--caution-medium, #f2b400);
              text-align: left;
              font-size: 24px;
              font-style: normal;
              font-weight: 700;
              line-height: 120%; /* 28.8px */
              font-family: 'Maison Neue', sans-serif !important;
            `}
          >
            Quick Game Access
          </span>
          <span
            css={css`
              color: var(--neutrals-white, #fff);
              font-size: 18px;
              font-style: normal;
              font-weight: 500;
              line-height: 120%; /* 21.6px */
              font-family: 'Maison Neue', sans-serif !important;
            `}
          >
            If you have the SportNinja app on your phone, you can scan the QR
            code with your camera. Then, tap the pop-up to open the game in the
            app.
          </span>
        </div>
        <div
          css={css`
            border: 8px solid ${colors.WHITE};
            border-radius: 8px;
          `}
        >
          <QRCode
            size={256}
            css={css`
              width: 144px;
              height: 144px;
            `}
            value={
              isCanlan
                ? `https://canlanstats.sportninja.com/game/${gameId}`
                : `https://app.sportninja.com/game/${gameId}`
            }
          />
        </div>
      </div>
    </div>
  )
}

export default OpenInAppModal
